import type { i18n as I18nInstance } from 'i18next';
import type { QuestionConfigQuestionType } from '/index';

import { questionScopeCategories } from '/business/shared/util/Statics';

import EvCarIcon from '/business/shared/images/icons/icon-ev-car.svg';
import initiativeCardBackground from '/business/shared/images/initiatives/EV-card-1x.jpg';
import initiativeBackground from '/business/shared/images/initiatives/EV-card-2x.jpg';

import useEvChargingSchema from '/business/shared/components/questions/scope2/_hooks/useEvChargingSchema';
import EVImageCard from '/business/shared/images/initiatives/EV-card-image.jpg';
import EVImageHeader from '/business/shared/images/initiatives/EV-header.jpg';
import educationContentJson from '/business/shared/components/questions/scope2/_education/ev-charging.json';

interface ConfigureEvChargingOptions {
  i18n: I18nInstance;
  reductionCardsSlides?: string[];
}

export const getConfigureEvCharging = ({
  i18n,
  reductionCardsSlides = ['slide1', 'slide2', 'slide3'],
}: ConfigureEvChargingOptions): QuestionConfigQuestionType => {
  return {
    id: 'ev-charging',
    scopeCategory: questionScopeCategories.SCOPE_2,
    apiKey: 'calculation-ev-charging',
    title: i18n.t('business:Questions.calculations.evCharging.title'),
    overviewPageTitleI18nKey: 'business:Questions.calculations.evCharging.title',
    primaryI18nKey: 'business:Questions.calculations.evCharging.title',
    subTextI18nKey: 'business:Questions.calculations.evCharging.subText',
    icon: EvCarIcon,
    isCompletePropName: 'evCharging',
    reductionPageKey: 'evCharging',
    reductionPageChartTitle: i18n.t('business:Questions.calculations.evCharging.title'),
    reductionPageCards: reductionCardsSlides,
    reductionPageIntroIsLowerCase: false,
    education: {
      hasEducationWidget: true,
      educationContent: educationContentJson,
      hasNoBottomSection: true,
    },
    initiative: {
      formatForInitiativeSummary: () => {
        return {
          isShowingReportingPeriod: false,
          isShowingReportingPeriodNoReduction: true,
          category: false,
          description:
            'Remaining non renewable electricity consumption to reduce after incorporating the initiatives already added to the plan so far',
          descriptionNoReduction: 'Non renewable electricity consumption for EV on the go during the reporting period ',
        };
      },
      getVisuals: ({ isBpOffering }) => {
        if (!isBpOffering) {
          return {
            description: false,
            background: initiativeBackground,
            useMask: false,
            cardBackground: initiativeCardBackground,
          };
        }
        if (isBpOffering) {
          return {
            description: false,
            background: EVImageHeader,
            useMask: false,
            cardBackground: EVImageCard,
          };
        }
      },
    },
    useHookLoader: useEvChargingSchema,
    selector: {
      injectQuestionBranchSelector: false,
    },
  };
};
